import useBySymbol from "backend/hooks/elements/useBySymbol";
import useHierarchy from "backend/hooks/elements/useHierarchy";
import useScorecardTopElement from "backend/hooks/model/useScorecardTopElement";
import StrategyToolbar from "components/toolbars/StrategyToolbar";
import StrategyGridWithThemes from "design/components/tables/StrategyGridWithThemes";
import PageContainer from "design/layouts/PageContainer";
import Page from "design/pages/Page";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useLink from "qpr-base/hooks/useLink";
import React from "react";
import typeToView from "routing/typetoview";

const StrategyMap = () => {
  const ctx = useAppContext();

  const { data: root } = useScorecardTopElement("L0");

  const link = useLink();
  const { data, isLoading: isDataLoading } = useHierarchy(
    ctx.elementId || root?.id
  );

  const { data: theme } = useBySymbol("D0_T");
  const { data: themeHierarchy, isLoading: isThemesLoading } = useHierarchy(
    theme?.id
  );

  // set themes visible/hidden in Strategy Map view
  const showThemes = false;

  return (
    <Page isLoading={!data || isDataLoading} Toolbar={StrategyToolbar}>
      <PageContainer>
        <StrategyGridWithThemes
          primaryThemeColors={["#00AEC7e3", "#FDDA25e3", "#00843De4"]}
          primaryThemeTextColors={["#fff", "#000", "#fff"]}
          defaultThemeColor="#888a"
          elements={
            data?.sort((a, b) => a.symbol.localeCompare(b.symbol)) || []
          }
          themes={(showThemes ? themeHierarchy || [] : [])
            .sort((a, b) => a.symbol.localeCompare(b.symbol))
            .slice(0, 3)}
          onSelect={(el) => {
            link({ page: typeToView(el.typename), meaId: el.id });
          }}
        />
      </PageContainer>
    </Page>
  );
};
export default StrategyMap;
